// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__5-TEU","rootSuccess":"CompleteLink_rootSuccess__1tu-_","rootFailure":"CompleteLink_rootFailure__3QL5F","isDisabled":"CompleteLink_isDisabled__x2GKt"};